import { toDate as e } from "./toDate.js";
function l(t) {
  return e(t).getMilliseconds();
}
export {
  l as default,
  l as getMilliseconds
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/getMilliseconds.js
// module id = 1389
// module chunks = 67